define('components/asset-player/main',[
    'components/asset-player/collections/assets',
    'components/asset-player/radio-channel',
    'components/asset-player/views/player'
], function (assets, channel, playerView) {
    "use strict";

    return {
        "assets": assets,
        "channel": channel,
        "view": playerView
    };
});

